import React from "react";

import { Access } from "common";
import { Form } from "components";
import { Regions, Stores } from "components/Filters";

const plans = [
  { value: 0, label: "MEMBROS CADASTRADOS" },
  { value: 1, label: "CLIENTES FINAIS ATIVOS" },
  { value: 2, label: "EXECUTOR ATIVO" },
  { value: 3, label: "TOTAL EAD ATIVOS" },
  { value: 4, label: "EAD ATIVOS COM DOCUMENTAÇÃO" },
  { value: 5, label: "EAD ATIVOS SEM DOCUMENTAÇÃO" },
  { value: 6, label: "MEMBROS REMOVIDOS" },
  { value: 7, label: "LEAD/CADASTRADOS" },
];

export default function Filters({ data, onChange, onClean }) {
  const storeFilters = { regions: [data.region] };

  return (
    <Form className="row form-filters">
      <Form.Field className="col-md-2">
        <Form.Label>Regiões</Form.Label>
        <Regions
          value={data.region}
          onChange={(value) => onChange("region", value)}
        />
      </Form.Field>

      <Form.Field className="col-md-2">
        <Form.Label>Lojas</Form.Label>
        <Stores
          isMulti
          value={data.stores}
          onChange={(value) => onChange("stores", value)}
          isDisabled={!!Access.lockedStore()}
          filters={storeFilters}
        />
      </Form.Field>

      <Form.Field className="col-md-2">
        <Form.Label>Período, de</Form.Label>
        <Form.Icon name="calendar">
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={data.date_start}
            onChange={(value) => onChange("date_start", value)}
          />
        </Form.Icon>
      </Form.Field>

      <Form.Field className="col-md-2">
        <Form.Label>Período, até</Form.Label>
        <Form.Icon name="calendar">
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={data.date_end}
            onChange={(value) => onChange("date_end", value)}
            minDate={data.date_start}
            disabled={data.date_start === null}
          />
        </Form.Icon>
      </Form.Field>

      <Form.Field className="col-md-2">
        <Form.Label>Status</Form.Label>
        <Form.Select
          placeholder="Status"
          value={data.plan}
          options={plans}
          onChange={(value) => onChange("plan", value)}
        />
      </Form.Field>

      <Form.Field className="col-md-2">
        <Form.Button className="button-clean-filter" onClick={onClean}>
          Resetar Filtro
        </Form.Button>
      </Form.Field>
    </Form>
  );
}
